import React, { createContext, useState, useCallback } from 'react';

const ProjectsContext = createContext();

export const ProjectsProvider = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedService, setSelectedService] = useState('');
  const [selectedExpertise, setSelectedExpertise] = useState('');
  const [selectedYear, setSelectedYear] = useState(null);
  // filterMode: 'timeline' (default) or 'filters' (dropdowns visible)
  const [filterMode, setFilterMode] = useState('timeline');

  // Switch to filter mode: reset timeline to most recent year, show dropdowns
  const activateFilterMode = useCallback((mostRecentYear) => {
    setFilterMode('filters');
    setSelectedYear(mostRecentYear);
  }, []);

  // Switch back to timeline mode: clear filters, hide dropdowns
  const activateTimelineMode = useCallback(() => {
    setFilterMode('timeline');
    setSelectedCountry('');
    setSelectedService('');
  }, []);

  return (
    <ProjectsContext.Provider
      value={{
        selectedCountry,
        setSelectedCountry,
        selectedService,
        setSelectedService,
        selectedExpertise,
        setSelectedExpertise,
        selectedYear,
        setSelectedYear,
        filterMode,
        setFilterMode,
        activateFilterMode,
        activateTimelineMode,
      }}
    >
      {children}
    </ProjectsContext.Provider>
  );
};

export default ProjectsContext;
